import { IMutationWithoutPayload, IMutation } from '@/store/types/mutation'
import { IState, ITranscoHyperProxi } from './types'
import {
  GET_TRANSCO_HYPER_PROXI_INIT,
  GET_TRANSCO_HYPER_PROXI_SUCCESS,
  GET_TRANSCO_HYPER_PROXI_ERROR,
  GET_TRANSCO_HYPER_PROXI_PRODUCT_INIT,
  GET_TRANSCO_HYPER_PROXI_PRODUCT_SUCCESS,
  GET_TRANSCO_HYPER_PROXI_PRODUCT_ERROR,
  GET_CREATED_TRANSCO_HYPER_PROXI_INIT,
  GET_CREATED_TRANSCO_HYPER_PROXI_SUCCESS,
  GET_CREATED_TRANSCO_HYPER_PROXI_ERROR,
  GET_MODIFY_TRANSCO_HYPER_PROXI_INIT,
  GET_MODIFY_TRANSCO_HYPER_PROXI_SUCCESS,
  GET_MODIFY_TRANSCO_HYPER_PROXI_ERROR,
  GET_DELETE_TRANSCO_HYPER_PROXI_INIT,
  GET_DELETE_TRANSCO_HYPER_PROXI_SUCCESS,
  GET_DELETE_TRANSCO_HYPER_PROXI_ERROR,
  UPDATE_PROVIDER_SEARCH,
  UPDATE_PRODUCT_SEARCH,
} from './mutations-types'

const mutationGetTranscoHyperProxiInit: IMutationWithoutPayload<IState> = (state) => {
  state.isLoading = true
  state.areTranscosLoaded = false
}

const mutationGetTranscoHyperProxiSuccess: IMutation<
  IState,
  ITranscoHyperProxi[]
> = (state, transcoHyperProxi) => {
  state.isLoading = false
  state.areTranscosLoaded = true
  state.transcoHyperProxi = transcoHyperProxi
}

const mutationsGetTranscoHyperProxiError: IMutationWithoutPayload<IState> = (state) => {
  state.isLoading = false
  state.areTranscosLoaded = false
  state.transcoHyperProxi = []
}

const mutationGetTranscoHyperProxiProductInit: IMutationWithoutPayload<IState> = (state) => {
  state.isLoading = true
  state.areTranscosProductsLoaded = false
}

// tslint:disable-next-line: max-line-length
const mutationGetTranscoHyperProxiProductSuccess: IMutation<
  IState,
  ITranscoHyperProxi[]
> = (state, transcoHyperProxiProduct) => {
  state.isLoading = false
  state.areTranscosProductsLoaded = true
  state.transcoHyperProxiProduct = transcoHyperProxiProduct
}

const mutationsGetTranscoHyperProxiProductError: IMutationWithoutPayload<IState> = (state) => {
  state.isLoading = false
  state.areTranscosProductsLoaded = false
  state.transcoHyperProxiProduct = []
}

const mutationCreatedTranscoHyperProxiInit: IMutationWithoutPayload<IState> = (state) => {
  state.isCreated = false
}

const mutationCreatedTranscoHyperProxiSuccess: IMutation<
  IState,
  ITranscoHyperProxi
> = (state, item) => {
  state.isCreated = true
  state.transcoHyperProxi = [...state.transcoHyperProxi, item]
}

const mutationsCreatedTranscoHyperProxiError: IMutationWithoutPayload<IState> = (state) => {
  state.isCreated = false
}

const mutationModifyTranscoHyperProxiInit: IMutationWithoutPayload<IState> = (state) => {
  state.isModified = false
}

const mutationModifyTranscoHyperProxiSuccess: IMutation<
  IState,
  ITranscoHyperProxi
> = (state, item) => {
  state.isModified = true
  const index = state.transcoHyperProxi.findIndex(
    (transco) =>
      transco.hyperCode === item.hyperCode &&
      transco.proxiCode === item.proxiCode,
  )
  if (index > -1) {
    state.transcoHyperProxi.splice(index, 1, item)
  }
}

const mutationsModifyTranscoHyperProxiError: IMutationWithoutPayload<IState> = (state) => {
  state.isModified = false
}

const mutationDeleteTranscoHyperProxiInit: IMutationWithoutPayload<IState> = (state) => {
  state.isDeleted = false
}

const mutationDeleteTranscoHyperProxiSuccess: IMutation<
  IState,
  ITranscoHyperProxi
> = (state, item) => {
  state.isDeleted = true
  const index = state.transcoHyperProxi.findIndex(
    (transco) =>
      transco.hyperCode === item.hyperCode &&
      transco.proxiCode === item.proxiCode,
  )
  if (index > -1) {
    state.transcoHyperProxi.splice(index, 1)
  }
}

const mutationsDeleteTranscoHyperProxiError: IMutationWithoutPayload<IState> = (state) => {
  state.isDeleted = false
}

const mutationProviderSearch: IMutation<IState, string> = (state, query) => {
  state.providerSearch = query
}

const mutationProductSearch: IMutation<IState, string> = (state, query) => {
  state.productSearch = query
}

export default {
  [GET_TRANSCO_HYPER_PROXI_INIT]: mutationGetTranscoHyperProxiInit,
  [GET_TRANSCO_HYPER_PROXI_SUCCESS]: mutationGetTranscoHyperProxiSuccess,
  [GET_TRANSCO_HYPER_PROXI_ERROR]: mutationsGetTranscoHyperProxiError,
  [GET_TRANSCO_HYPER_PROXI_PRODUCT_INIT]: mutationGetTranscoHyperProxiProductInit,
  [GET_TRANSCO_HYPER_PROXI_PRODUCT_SUCCESS]: mutationGetTranscoHyperProxiProductSuccess,
  [GET_TRANSCO_HYPER_PROXI_PRODUCT_ERROR]: mutationsGetTranscoHyperProxiProductError,
  [GET_CREATED_TRANSCO_HYPER_PROXI_INIT]: mutationCreatedTranscoHyperProxiInit,
  [GET_CREATED_TRANSCO_HYPER_PROXI_SUCCESS]: mutationCreatedTranscoHyperProxiSuccess,
  [GET_CREATED_TRANSCO_HYPER_PROXI_ERROR]: mutationsCreatedTranscoHyperProxiError,
  [GET_MODIFY_TRANSCO_HYPER_PROXI_INIT]: mutationModifyTranscoHyperProxiInit,
  [GET_MODIFY_TRANSCO_HYPER_PROXI_SUCCESS]: mutationModifyTranscoHyperProxiSuccess,
  [GET_MODIFY_TRANSCO_HYPER_PROXI_ERROR]: mutationsModifyTranscoHyperProxiError,
  [GET_DELETE_TRANSCO_HYPER_PROXI_INIT]: mutationDeleteTranscoHyperProxiInit,
  [GET_DELETE_TRANSCO_HYPER_PROXI_SUCCESS]: mutationDeleteTranscoHyperProxiSuccess,
  [GET_DELETE_TRANSCO_HYPER_PROXI_ERROR]: mutationsDeleteTranscoHyperProxiError,
  [UPDATE_PROVIDER_SEARCH]: mutationProviderSearch,
  [UPDATE_PRODUCT_SEARCH]: mutationProductSearch,
}
